import { FlowManager } from 'react-flow-app';

import { screens } from '@screens';

export const flowManager = new FlowManager(screens);
